import React from 'react';
import styled from 'styled-components';
import { RelationalOperatorKey } from '../../../../../../utils/apollo/graphqlSchema';
import { IMeasureFilterValue } from '../../../../../../redux/slices/oldBuilder';
import { assertNotNil } from '../../../../../../utils/types';
import { theme } from '../../../../../../styles/theme';

interface IProps {
  measureFilterValue: IMeasureFilterValue;
}

const Container = styled.div`
  display: inline-flex;
  column-gap: 4px;
  align-items: center;
`;

const MeasureKey = styled.div`
  font-weight: 600;
  line-height: 1.5;
  color: ${theme.colors.secondary900};
`;

const FilterLabel = styled.div`
  font-weight: 500;
  line-height: 1.5;
  color: ${theme.colors.mainBlue};
`;

const ValueLabel = styled(FilterLabel)`
  font-weight: 600;
`;

const MeasureFilterDisplayValue = ({ measureFilterValue }: IProps) => {
  const { measureKey, filter } = measureFilterValue;

  assertNotNil(filter);

  const { relOp, values } = filter;

  if (relOp.key === RelationalOperatorKey.Between) {
    return (
      <Container>
        <ValueLabel>{values[0]}</ValueLabel>
        <FilterLabel>≤</FilterLabel>
        <MeasureKey>{measureKey}</MeasureKey>
        <ValueLabel>≤</ValueLabel>
        <ValueLabel>{values[1]}</ValueLabel>
      </Container>
    );
  }

  return (
    <Container>
      <MeasureKey>{measureKey}</MeasureKey>
      <FilterLabel>{relOp.name}</FilterLabel>
      <ValueLabel>{values[0]}</ValueLabel>
    </Container>
  );
};

export default MeasureFilterDisplayValue;
